/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_User_TitleInputs */

const en_select_user_title = /** @type {(inputs: Select_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select User`)
};

const es_select_user_title = /** @type {(inputs: Select_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar usuario`)
};

/**
* | output |
* | --- |
* | "Select User" |
*
* @param {Select_User_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_user_title = /** @type {((inputs?: Select_User_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_User_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_user_title(inputs)
	return es_select_user_title(inputs)
});